import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function StickyTopBar() {
  const {
    minutes,
    seconds,
    isUrgent
  } = useCountdown(15);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 right-0 z-50 bg-brand-dark text-white py-1.5 px-3 shadow-md" data-id="element-302">
      <div className="max-w-5xl mx-auto flex flex-col items-center gap-0.5 text-xs md:text-sm" data-id="element-303">
        <div className="font-bold text-center" data-id="element-304">PRECIO DE LANZAMIENTO —</div>
        <div className="flex items-center gap-1.5 font-bold text-center" data-id="element-305">
          <span className="animate-pulse" data-id="element-306">⏰</span>
          <span data-id="element-307">Cierra en:</span>
          <span className={`text-brand-orange font-black text-base tracking-wider ${isUrgent ? 'animate-pulse' : ''}`} data-id="element-308">
            {formatTime(minutes)}:{formatTime(seconds)}
          </span>
        </div>
        <a href="https://checkout.guiadigital360.online/cart/44819876446277:1" className="bg-brand-green hover:bg-[#009a6a] text-white font-bold py-1 px-5 rounded-full text-xs transition-colors whitespace-nowrap" data-id="element-309">
          ASEGURAR PRECIO
        </a>
      </div>
    </div>;
}